<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

export default {
    name: '',
    components: {
    },
    methods: {

    },
    mounted () {

    }
}
</script>

<style scoped>
    #app {
        height: 100%;
        font-size: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/page/cw/App.vue